import { PopupOfferType } from "Utility/Helpers/IAP/PopupOffers";
import { AdDebugMode } from "State/Game/AdDebugMode";
import { IAPDebugMode } from "./IAPDebugMode";

export interface IPerSessionData {
    offersSeen: PopupOfferType[];
    isNewUser: boolean;

    hasClickedXPromoHUDButton: boolean;
    debugXPromo?: boolean;
    adDebugMode: AdDebugMode;
    iapDebugMode: IAPDebugMode;
}

export const initialPerSessionDataState: IPerSessionData = {
    offersSeen: [],
    isNewUser: false,
    hasClickedXPromoHUDButton: false,
    adDebugMode: AdDebugMode.DEFAULT,
    iapDebugMode: IAPDebugMode.DEFAULT
};
